/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editevent1Inputs */

const en_editevent1 = /** @type {(inputs: Editevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Event`)
};

const de_editevent1 = /** @type {(inputs: Editevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit Event" |
*
* @param {Editevent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editevent1 = /** @type {((inputs?: Editevent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editevent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editevent1(inputs)
	return de_editevent1(inputs)
});
export { editevent1 as "editEvent" }